import { CircularProgress } from "@mui/joy";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import { UpdatePassword } from "../types/auth";
import { selectCurrentUser } from "../api/auth/authSlice";
import { useSelector } from "react-redux";
import { useChangeUserPasswordMutation } from "../api/auth/authApi";
import { useState } from "react";
import { getErrorMessage } from "../utils/errorHelpers";
import { ErrorMessage } from "../components/UtilitiesComponents/ErrorMessage";

export function CambiarPassword() {
    const navigate = useNavigate();
    const user = useSelector(selectCurrentUser);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const [updatePassword, { isLoading }] = useChangeUserPasswordMutation();

    const {
        register,
        handleSubmit,
        formState: {
            errors,
        }
    } = useForm<UpdatePassword>()

    const updatePasswordHandle = handleSubmit(async (data: UpdatePassword) => {
        try {
            setErrorMessage(null);

            const userId: number = user ? user.id : 0

            const request = {
                userId: userId,
                body: data,
            }

            await updatePassword(request).unwrap();

            navigate(-1);
            
        } catch (error) {
            setErrorMessage(getErrorMessage(error));
        }
    });

    return (
        <div className="h-full w-full p-3">
            
            <p className="text-center font-semibold text-2xl my-4">Cambiar contraseña</p>

            <div className="flex justify-center">
                <form
                    onSubmit={updatePasswordHandle}
                    className="grid w-96 gap-y-4" autoComplete="off">

                    <div className="grid">
                        <label className="text-[13px] font-semibold">Contraseña actual</label>
                        <input 
                            {...register("currentPassword", {
                                required: "El campo es requerido",
                            })}
                            className={`h-[40px] rounded border-gray-400 border px-2 
                                font-semibold text-gray-600 text-sm`}
                            type={"text"}/>
                    </div>

                    {errors.currentPassword?.type === "required" && (
                        <p className="valErrorText">{errors.currentPassword.message}</p>
                    )}

                    <div className="grid">
                        <label className="text-[13px] font-semibold">Nueva contraseña</label>
                        <input 
                            {...register("newPassword", {
                                required: "El campo es requerido",
                            })}
                            className={`h-[40px] rounded border-gray-400 border px-2 
                                font-semibold text-gray-600 text-sm`}
                            type={"text"}/>
                    </div>

                    {errors.newPassword?.type === "required" && (
                        <p className="valErrorText">{errors.newPassword.message}</p>
                    )}

                    <div className="grid">
                        <label className="text-[13px] font-semibold">Confirmar contraseña</label>
                        <input 
                            {...register("confirmNewPassword", {
                                required: "El campo es requerido",
                            })}
                            className={`h-[40px] rounded border-gray-400 border px-2 
                                font-semibold text-gray-600 text-sm`}
                            type={"text"}/>
                    </div>

                    {errors.confirmNewPassword?.type === "required" && (
                        <p className="valErrorText">{errors.confirmNewPassword.message}</p>
                    )}

                    {errorMessage && (
                        <div className="my-2">
                            <ErrorMessage
                            customMessage>
                                <p className="text-sm">{errorMessage}</p>
                            </ErrorMessage>
                        </div>
                    )}

                    {isLoading
                    ? 
                    <div className="flex justify-center">
                        <CircularProgress />
                    </div>
                    :
                    <div className="grid grid-cols-2 gap-x-2">
                        <input
                            className="font-semibold bg-green-800 rounded my-1 py-1 px-2 text-white h-[40px] text-sm wd-[80px]"
                            type="submit"
                            value="Confirmar"/>

                        <button 
                            type="button"
                            className="border-2 border-gray-300 rounded px-[6px] my-1 py-1 items-center wd-[80px] text-center text-sm text-gray-800 font-semibold hover:bg-gray-100 h-[40px]"
                            onClick={() => navigate(-1)}>
                            Cancelar
                        </button>
                    </div>
                    }

                </form>
            </div>
        </div>
    );
}